import type { ReactNode } from "react";
import { LegalAgreePromptModal } from "./LegalAgreePromptModal";

export type AgreePromptOptions = {
  title?: string;
  confirmText?: string;
  children: ReactNode;
};

type Props = {
  open: boolean;
  promptOptions: AgreePromptOptions;
  promptChecked: boolean;
  onCheckedChange: (checked: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
};

export function UseAgreeGateModal(props: Props) {
  const {
    open,
    promptOptions,
    promptChecked,
    onCheckedChange,
    onCancel,
    onConfirm,
  } = props;

  return (
    <LegalAgreePromptModal
      open={open}
      title={promptOptions.title}
      confirmText={promptOptions.confirmText}
      checked={promptChecked}
      onCheckedChange={onCheckedChange}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      {promptOptions.children}
    </LegalAgreePromptModal>
  );
}
